import { router } from 'expo-router';
import React from 'react';

import { Button, Center, Text, VStack } from '@squire/ui';

import { useErrorTranslations } from '@/hooks/useErrorTranslations';
import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { ViewReservationErrorFallbackProps } from './types';

const ViewReservationErrorFallback: React.FC<
  ViewReservationErrorFallbackProps
> = ({ error, resetErrorBoundary }) => {
  const { t } = useScreenTranslations('ViewReservationErrorFallback');
  const { t: errorT } = useErrorTranslations('appointment');

  const { details } = error as unknown as Error & { details?: string };

  const handleTakeMeHome = () => router.dismissAll();

  return (
    <Center style={styles.errorContainer}>
      <VStack space={16}>
        <Text variant="lStrong" color="textPrimary">
          {t('title')}
        </Text>
        <Text variant="m" color="textSecondary" align="center">
          {details || errorT('unknownError')}
        </Text>
        <Button onPress={resetErrorBoundary} variant="primary">
          {t('retry')}
        </Button>

        {error.message === 'SALE_HAS_ERRORS' && (
          <Button onPress={handleTakeMeHome} variant="secondary">
            {t('takeMeHome')}
          </Button>
        )}
      </VStack>
    </Center>
  );
};

ViewReservationErrorFallback.displayName = 'ViewReservationErrorFallback';
export { ViewReservationErrorFallback };
